import { QueryClient } from "@tanstack/react-query";
import axios from "axios";

/**
 * Retry once on network/5xx blips, never on a 4xx the server already decided.
 *
 * 429 is the one that matters: the API applies a per-user rate throttle, so a
 * retry goes straight back into the bucket that is already empty, doubles the
 * traffic that emptied it, and turns a brief burst into a self-sustaining
 * storm of "Żądanie zostało zdławione" errors. 401 is handled by the axios
 * interceptor (token refresh + replay), so it needs no retry here either.
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  const status = axios.isAxiosError(error) ? error.response?.status : undefined;
  if (status !== undefined && status >= 400 && status < 500) return false;
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetry,
      refetchOnWindowFocus: false,
    },
  },
});
